// extracted by mini-css-extract-plugin
export default {"description":"VhL8dkWlgtQvIwjF6QFh","stripeBlock":"UvnT9eXZYQm0OIXmm1kq","linkTitle":"bri71cFkGULTevywtMiF"};